/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var PureRenderMixin, React, ReactDOM, Score, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

Score = require('./score');

css = require('../css/result.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  displayName: 'Result',
  handleDestroyGame: function() {
    return this.props.actions.destroyGame(this.props.game.id);
  },
  render: function() {
    var destroyGameBtn, me, players;
    me = null;
    players = this.props.game.players.map((function(_this) {
      return function(player) {
        if (player.id === _this.props.user.data.id) {
          me = player;
        }
        return React.createElement("div", {
          "key": player.id,
          "className": css['player']
        }, React.createElement("span", {
          "className": css['player-name']
        }, player.nickname, ": "), React.createElement("span", {
          "className": css['player-points']
        }, player.points));
      };
    })(this));
    if (me != null ? me.master : void 0) {
      destroyGameBtn = React.createElement("div", {
        "className": "btn btn-danger",
        "onClick": this.handleDestroyGame
      }, "Zrušit hru");
    }
    return React.createElement("div", {
      "className": css['result']
    }, React.createElement(Score, {
      "game": this.props.game,
      "user": this.props.user
    }), React.createElement("div", {
      "className": css['buttons']
    }, destroyGameBtn));
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "result.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/result.cjsx
 ** module id = 277
 ** module chunks = 0
 **/